import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryCostComparison: BlogMetaData = {
  title: '認可外保育園の料金は本当に高い？習い事込みの総コスト比較【神戸・灘区版】',
  description:
    '認可外保育園の料金は本当に高いのか？無償化補助・習い事コストを含めた総コスト（TCO）で認可保育園と正直に比較。灘区の認可保育園とみらいキッズモンテプリスクールの実例から、保護者が知るべき選び方の基準を解説します。',
  thumbnailUrl: '/img/blog-nursery-cost-comparison.webp',
  filePath: buildBlogFilePath('nursery-cost-comparison'),
  category: BLOG_CATEGORY.NURSERY,
};
